// this was autogenerated by gulpTimezonePlugin from the timezone source in node_modules
(window.__PRELOADED_TIMEZONE_DATA__ || (window.__PRELOADED_TIMEZONE_DATA__ = {}))['nn_NO']  = { // eslint-disable-line import/no-commonjs
  name: 'nn_NO',
  day: {
    abbrev: ['sø.', 'må.', 'ty.', 'on.', 'to.', 'fr.', 'la.'],
    full: [
      'sundag',
      'måndag',
      'tysdag',
      'onsdag',
      'torsdag',
      'fredag',
      'laurdag'
    ]
  },
  month: {
    abbrev: [
      'jan.',
      'feb.',
      'mars',
      'april',
      'mai',
      'juni',
      'juli',
      'aug.',
      'sep.',
      'okt.',
      'nov.',
      'des.'
    ],
    full: [
      'januar',
      'februar',
      'mars',
      'april',
      'mai',
      'juni',
      'juli',
      'august',
      'september',
      'oktober',
      'november',
      'desember'
    ]
  },
  meridiem: ['', ''],
  date: '%Y-%m-%d',
  time24: 'kl. %H.%M %z',
  dateTime: '%b %-d at %l:%M%P',
  time12: '',
  full: '%b %-d, %Y %-l:%M%P'
}

